import { z } from 'zod';
import { validationMessagesMap } from 'src/utils/messages';
import { CURRENCY } from 'src/types';

export type DiscountPolicyFormSchemaValues = z.infer<typeof discountPolicyFormSchema>;
export const discountPolicyFormSchema = z
    .object({
        name: z.string().nonempty(),
        valid_from: z.string().nonempty(),
        valid_to: z.string().optional().nullable(),
        description: z.string().optional().nullable(),
        amount: z.number().int().min(0).optional().nullable(),
        percent: z
            .string()
            .optional()
            .nullable()
            .refine(
                (val) => {
                    if (!val) return true;
                    const num = Number(val);
                    return !isNaN(num) && num >= 0 && num <= 100;
                },
                {
                    message: validationMessagesMap.validationErrorPercent,
                },
            ),
        valid_duration: z.string().optional().nullable(),
        manual_valid_duration: z.boolean(),
        max_applications: z.number().int().min(0).optional().nullable(),
        max_applications_per_customer: z.number().int().min(0).optional().nullable(),
        service_plans: z.array(z.string()).optional().nullable(),
        service_plan_items: z.array(z.string()).optional().nullable(),
        currency: z.enum(CURRENCY),
    })
    .superRefine((data, ctx) => {
        if (data.amount && !data.percent) return;
        if (!data.amount && data.percent) return;

        if (!data.amount && !data.percent) {
            ctx.addIssue({
                path: ['percent'],
                message: validationMessagesMap.validationErrorDiscountPolicy,
                code: 'custom',
            });
            ctx.addIssue({
                path: ['amount'],
                message: validationMessagesMap.validationErrorDiscountPolicy,
                code: 'custom',
            });
        }
    });
